// Banner que muestra solicitudes pendientes del abogado
import { Link } from 'react-router-dom';
import { InboxArrowDownIcon } from '@heroicons/react/24/outline';
import { useClienteSolicitudesCount } from '@/hooks/useClienteSolicitudes';

export function ClienteSolicitudesBanner() {
  const { count, isLoading } = useClienteSolicitudesCount();

  if (isLoading || count === 0) return null;

  const texto = count === 1
    ? 'Tienes 1 solicitud pendiente'
    : `Tienes ${count} solicitudes pendientes`;

  return (
    <Link to="/clientes/solicitudes">
      <div className="flex items-center gap-3 rounded-lg bg-amber-50 dark:bg-amber-950 border border-amber-200 dark:border-amber-800 px-4 py-3 hover:bg-amber-100 dark:hover:bg-amber-900 transition-colors">
        <InboxArrowDownIcon className="h-5 w-5 text-amber-600 dark:text-amber-400 flex-shrink-0" />
        <p className="text-sm font-medium text-amber-800 dark:text-amber-200 flex-1">
          {texto}
        </p>
        <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-amber-200 dark:bg-amber-800 text-xs font-bold text-amber-900 dark:text-amber-100">
          {count}
        </span>
      </div>
    </Link>
  );
}
